// src/pages/services/ServiceDetailPage.js
import React, { Fragment } from "react";
import { useParams, Link } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ServicesDropdown from "./ServicesDropdown";
import servicesData from "./servicesData";
import { FaHandsHelping } from "react-icons/fa";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const ServiceDetailPage = (props) => {
  const { slug } = useParams();

  // if slug exists → load from ServicesData
  let service = slug ? null : null;

  // if no slug but props are given → use props
  if (!service && props.title) {
    service = {
      title: props.title,
      heading: props.heading,
      intro: props.intro,
      image: props.image,
      description: props.overview || props.description,
      features: props.services || [],
      benefitsIntro: props.benefitsIntro,
      benefits: props.projects || props.benefits || [],
      research: props.research,
    };
  }

  if (!service) {
    return (
      <Fragment>
        <PageTitle pageTitle="Service Not Found" pagesub={"Services"} />
        <section className="section-padding text-center">
          <div className="container">
            <h2>Oops! Service not found.</h2>
            <Link to="/services" className="theme-btn">
              Back to Services
            </Link>
          </div>
        </section>
        <Scrollbar />
      </Fragment>
    );
  }

  // Helper to split benefits into columns if it's a flat array
  const formattedBenefits = Array.isArray(service.benefits[0])
    ? service.benefits
    : [
        service.benefits.slice(0, Math.ceil(service.benefits.length / 2)),
        service.benefits.slice(Math.ceil(service.benefits.length / 2)),
      ];

  return (
    <Fragment>
      <PageTitle pageTitle={service.title} />

      <section
        className="service-single-section section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div className="container">
          <div className="row g-4">
            {/* Main Content */}
            <div className="col col-lg-9 col-12">
              {/* Hero Card */}
              <div
                className="service-hero-card"
                style={{
                  background: "var(--primary-color)",
                  borderRadius: "15px",
                  padding: "60px 45px",
                  marginBottom: "40px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "250px",
                    height: "250px",
                    background: "rgba(255,255,255,0.05)",
                    borderRadius: "50%",
                  }}
                ></div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "20px",
                    width: "100px",
                    height: "100px",
                    background: "rgba(255,255,255,0.03)",
                    borderRadius: "50%",
                  }}
                ></div>
                <h1
                  style={{
                    color: "#fff",
                    fontSize: "2.8rem",
                    fontWeight: "800",
                    marginBottom: "25px",
                    position: "relative",
                    zIndex: 1,
                    lineHeight: "1.2",
                  }}
                >
                  {service.heading}
                </h1>
                {service.intro && (
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: "1.25rem",
                      lineHeight: "1.7",
                      marginBottom: 0,
                      position: "relative",
                      zIndex: 1,
                      maxWidth: "800px",
                    }}
                  >
                    {service.intro}
                  </p>
                )}
              </div>

              {/* Overview Section with Background Image */}
              {service.description && (
                <div
                  style={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "hidden",
                    marginBottom: "50px",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    minHeight: "450px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    backgroundColor: "var(--primary-color)",
                  }}
                >
                  {/* Background Image Layer */}
                  {service.image && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url("${service.image}")`, // Added quotes to handle spaces in filenames
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        zIndex: 0,
                      }}
                    />
                  )}

                  {/* Overlay for Dimming */}
                  {service.image && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background:
                          "linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.75))",
                        zIndex: 1,
                      }}
                    />
                  )}

                  {/* Content Layer */}
                  <div
                    style={{
                      position: "relative",
                      zIndex: 2,
                      padding: "60px 45px",
                      color: "#fff",
                    }}
                  >
                    <h3
                      style={{
                        color: "#fff",
                        fontSize: "2.2rem",
                        fontWeight: "800",
                        marginBottom: "30px",
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <span
                        style={{
                          width: "40px",
                          height: "5px",
                          background: "var(--primary-color)",
                          borderRadius: "10px",
                          boxShadow: "0 0 10px rgba(255,255,255,0.3)",
                        }}
                      ></span>
                      Overview
                    </h3>
                    <div
                      style={{
                        fontSize: "1.25rem",
                        lineHeight: "1.9",
                        textAlign: "justify",
                        color: "rgba(255,255,255,0.95)",
                      }}
                    >
                      {Array.isArray(service.description) ? (
                        service.description.map((para, i) => (
                          <p
                            key={i}
                            style={{
                              color: "inherit",
                              marginBottom:
                                i === service.description.length - 1
                                  ? 0
                                  : "25px",
                            }}
                          >
                            {para}
                          </p>
                        ))
                      ) : (
                        <p style={{ color: "inherit", marginBottom: 0 }}>
                          {service.description}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* Detailed Services Section */}
              {service.features?.length > 0 && (
                <div style={{ marginBottom: "60px" }}>
                  <div style={{ textAlign: "center", marginBottom: "45px" }}>
                    <h2
                      style={{
                        color: "var(--primary-color)",
                        fontSize: "2.4rem",
                        fontWeight: "800",
                        marginBottom: "15px",
                        letterSpacing: "-0.5px",
                      }}
                    >
                      Our Services Include
                    </h2>
                    <div
                      style={{
                        width: "60px",
                        height: "5px",
                        background:
                          "linear-gradient(to right, var(--primary-color), #2a52be)",
                        margin: "0 auto",
                        borderRadius: "10px",
                      }}
                    ></div>
                  </div>

                  <div className="row g-4">
                    {service.features.map((feat, idx) => (
                      <div className="col-lg-12" key={idx}>
                        <div
                          style={{
                            background: "#fff",
                            borderRadius: "15px",
                            padding: "0",
                            boxShadow: "0 15px 45px rgba(0,0,0,0.06)",
                            transition:
                              "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
                            border: "1px solid rgba(0,0,0,0.04)",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-8px)";
                            e.currentTarget.style.boxShadow =
                              "0 25px 60px rgba(0,0,0,0.12)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow =
                              "0 15px 45px rgba(0,0,0,0.06)";
                          }}
                        >
                          <div className="row g-0">
                            {/* Accent Bar */}
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "6px",
                                height: "100%",
                                background: "var(--primary-color)",
                              }}
                            ></div>

                            <div
                              className="col-md-1 d-none d-md-flex align-items-start justify-content-center"
                              style={{ paddingTop: "45px" }}
                            >
                              <div
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  background:
                                    "rgba(var(--primary-color-rgb), 0.08)",
                                  color: "var(--primary-color)",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "1.2rem",
                                  fontWeight: "800",
                                  border:
                                    "1px solid rgba(var(--primary-color-rgb), 0.1)",
                                }}
                              >
                                {idx + 1}
                              </div>
                            </div>

                            <div className="col-md-11 p-5">
                              <h4
                                style={{
                                  color: "var(--primary-color)",
                                  fontSize: "1.6rem",
                                  fontWeight: "700",
                                  marginBottom: "18px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px",
                                }}
                              >
                                {feat.title}
                              </h4>

                              <p
                                style={{
                                  color: "#526076",
                                  fontSize: "1.1rem",
                                  lineHeight: "1.7",
                                  marginBottom: feat.list ? "25px" : 0,
                                  fontWeight: "400",
                                }}
                              >
                                {feat.text}
                              </p>

                              {feat.list && (
                                <div className="row g-3">
                                  {feat.list.map((item, i) => (
                                    <div
                                      className="col-md-6 col-lg-4 d-flex"
                                      key={i}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "12px",
                                          padding: "14px 20px",
                                          background: "#fcfdfe",
                                          borderRadius: "12px",
                                          fontSize: "1rem",
                                          color: "#334155",
                                          border: "1px solid #f1f5f9",
                                          transition: "all 0.3s ease",
                                          width: "100%",
                                          height: "100%",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.02)",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "8px",
                                            height: "8px",
                                            background: "var(--primary-color)",
                                            borderRadius: "50%",
                                            opacity: 0.8,
                                            flexShrink: 0,
                                          }}
                                        ></div>
                                        <span
                                          style={{
                                            textTransform: "none",
                                            lineHeight: "1.4",
                                          }}
                                        >
                                          {item.charAt(0).toUpperCase() +
                                            item.slice(1)}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {feat.extraInfo && (
                                <div
                                  style={{
                                    marginTop: "25px",
                                    padding: "20px 25px",
                                    background:
                                      "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                                    borderRadius: "16px",
                                    border:
                                      "1px dashed rgba(var(--primary-color-rgb), 0.2)",
                                    fontSize: "1.05rem",
                                    color: "#64748b",
                                    lineHeight: "1.6",
                                    display: "flex",
                                    gap: "12px",
                                    alignItems: "baseline",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "var(--primary-color)",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Note:
                                  </span>
                                  <span>
                                    {feat.extraInfo.charAt(0).toUpperCase() +
                                      feat.extraInfo.slice(1)}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Benefits Section */}
              {service.benefits?.length > 0 && (
                <div
                  style={{
                    background: "var(--primary-color)",
                    borderRadius: "15px",
                    padding: "60px 45px",
                    marginBottom: "50px",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Background decoration */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-10%",
                      right: "-5%",
                      width: "300px",
                      height: "300px",
                      background: "rgba(255,255,255,0.1)",
                      borderRadius: "50%",
                      filter: "blur(50px)",
                    }}
                  ></div>

                  <h3
                    style={{
                      color: "#fff",
                      fontSize: "2.2rem",
                      fontWeight: "800",
                      marginBottom: "20px",
                      textAlign: "center",
                    }}
                  >
                    Benefits of This Service
                  </h3>

                  {service.benefitsIntro && (
                    <p
                      style={{
                        color: "rgba(255,255,255,0.85)",
                        fontSize: "1.2rem",
                        textAlign: "center",
                        marginBottom: "45px",
                        maxWidth: "700px",
                        margin: "0 auto 45px",
                      }}
                    >
                      {service.benefitsIntro}
                    </p>
                  )}

                  <div className="row g-4">
                    {formattedBenefits.map((col, colIndex) => (
                      <div className="col-md-6" key={colIndex}>
                        <ul
                          style={{ listStyle: "none", padding: 0, margin: 0 }}
                        >
                          {col.map((item, idx) => (
                            <li
                              key={idx}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                marginBottom: "20px",
                                fontSize: "1.1rem",
                                color: "#fff",
                              }}
                            >
                              <div
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  background: "rgba(255,255,255,0.2)",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: "15px",
                                  marginTop: "2px",
                                  flexShrink: 0,
                                }}
                              >
                                <span
                                  style={{
                                    color: "#fff",
                                    fontSize: "14px",
                                    fontWeight: "900",
                                  }}
                                >
                                  ✓
                                </span>
                              </div>
                              <span style={{ opacity: 0.95 }}>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Why Choose Us Section */}
              {service.research && (
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "45px",
                    marginBottom: "50px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    borderTop: "6px solid var(--primary-color)",
                  }}
                >
                  <h3
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    {props.researchTitle || "Why Choose Us"}
                  </h3>
                  <div
                    style={{
                      color: "#4a5568",
                      fontSize: "1.15rem",
                      lineHeight: "1.8",
                    }}
                  >
                    {Array.isArray(service.research) ? (
                      service.research.map((para, i) => (
                        <p
                          key={i}
                          style={{
                            marginBottom:
                              i === service.research.length - 1 ? 0 : "20px",
                          }}
                        >
                          {para}
                        </p>
                      ))
                    ) : (
                      <p style={{ marginBottom: 0 }}>{service.research}</p>
                    )}
                  </div>
                </div>
              )}

              {/* Final CTA */}
              <div style={{ textAlign: "center", marginTop: "60px" }}>
                <Link
                  onClick={ClickHandler}
                  to="/contact"
                  className="theme-btn"
                  style={{
                    padding: "20px 60px",
                    borderRadius: "50px",
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    transition:
                      "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                    background: "var(--primary-color)",
                    color: "#fff",
                    boxShadow:
                      "0 10px 30px rgba(var(--primary-color-rgb), 0.3)",
                    border: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  Consult an Expert Today
                  <span style={{ fontSize: "1.5rem" }}>→</span>
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col col-lg-3 col-12">
              <div style={{ position: "sticky", top: "100px" }}>
                {/* Services Dropdown */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "30px",
                    marginBottom: "30px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    border: "1px solid rgba(0,0,0,0.05)",
                  }}
                >
                  <ServicesDropdown
                    ClickHandler={ClickHandler}
                    ServicesData={servicesData}
                  />
                </div>

                {/* Quick Contact Widget */}
                <div
                  style={{
                    background: "var(--primary-color)",
                    borderRadius: "15px",
                    padding: "40px 30px",
                    textAlign: "center",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "rgba(255,255,255,0.15)",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 25px",
                      backdropFilter: "blur(5px)",
                    }}
                  >
                    <FaHandsHelping size={32} color="#fff" />
                  </div>
                  <h4
                    style={{
                      color: "#fff",
                      fontSize: "1.5rem",
                      fontWeight: "700",
                      marginBottom: "15px",
                    }}
                  >
                    Ready to Start?
                  </h4>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.85)",
                      fontSize: "1rem",
                      lineHeight: "1.6",
                      marginBottom: "30px",
                    }}
                  >
                    Get expert advice tailored to your specific business
                    requirements in India.
                  </p>
                  <Link
                    onClick={ClickHandler}
                    to="/contact"
                    style={{
                      display: "block",
                      background: "#fff",
                      color: "var(--primary-color)",
                      padding: "15px 25px",
                      borderRadius: "50px",
                      fontSize: "1.05rem",
                      fontWeight: "700",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 20px rgba(0,0,0,0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 5px 15px rgba(0,0,0,0.1)";
                    }}
                  >
                    Contact Support
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceDetailPage;
